module.exports = __webpack_public_path__ + "ca38f5c5d1c6509de200162f81a11d81.png";


//////////////////
// WEBPACK FOOTER
// ./assets/image/logo_rwm-white.png
// module id = 1157
// module chunks = 0